export default {"src":"/_next/static/media/ollie_font.6d3316f5.svg","height":25,"width":50,"blurWidth":0,"blurHeight":0};